module.exports = __webpack_public_path__ + "img/rune-illusions.0863690a.png";